import request from "./request.js";

export default {
  // 登录
  addPaper: (data) => {
    return request({
      url: "api/admin/paper/addPaper",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  updatePaper: (data) => {
    return request({
      url: "api/admin/paper/updatePaper",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
  showPapers: (data) => {
    return request({
      url: "api/admin/paper/showPapers",
      data: data,
      method: "post",
    }).then((res) => {
      return res.data;
    });
  },
};
